module.exports = __webpack_public_path__ + "img/rushden_horizontal.84cdd747.png";